import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { send } from "../../../app/appSlice"
import { AppThunkApi, RootState } from "../../../app/store"
import {
  getMedicalMessage,
  Medical,
  MedicalParams,
} from "../../../services/medical"
interface medicalState {
  medicalList: Medical[]
}

const initialState: medicalState = {
  medicalList: [],
}

// 列表数据
export const getMedicalListAsync = createAsyncThunk<
  Medical[],
  MedicalParams,
  AppThunkApi
>("MedicalList/page", async (params, api) => {
  return send(getMedicalMessage(params), api).then((data) => {
    return data.map((v: any) => {
      return {
        ...v,
        organizationTotal: v.acOrgTc,
      }
    })
  })
})

export const MedicalListSlice = createSlice({
  name: "MedicalListStation",
  initialState,
  reducers: {
    setMedicalList(state, action) {
      state.medicalList = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMedicalListAsync.fulfilled, (state, action: any) => {
      state.medicalList = action.payload
    })
  },
})

export const { setMedicalList } = MedicalListSlice.actions

export const selectMedicalList = (state: RootState) => state.medical.medicalList

export default MedicalListSlice.reducer
